import { useState, useEffect, useCallback } from 'react';

export default function Mascot() {
  const [eyeState, setEyeState] = useState<'open' | 'blink'>('open');
  const [bouncy, setBouncy] = useState(false);

  useEffect(() => {
    const iv = setInterval(() => {
      setEyeState('blink');
      setTimeout(() => setEyeState('open'), 200);
    }, 2500 + Math.random() * 2000);
    return () => clearInterval(iv);
  }, []);

  const handleClick = useCallback(() => {
    setBouncy(true);
    setTimeout(() => setBouncy(false), 500);
    window.location.hash = '#/relax';
  }, []);

  return (
    <div
      className="fixed"
      style={{
        bottom: '24px',
        right: '24px',
        width: '68px',
        height: '68px',
        zIndex: 50,
        cursor: 'pointer',
      }}
      onClick={handleClick}
      title="放松一下"
    >
      {/* 上方飘浮文字 - 放松一下 */}
      <div
        className="absolute"
        style={{
          top: '-32px',
          left: '50%',
          transform: 'translateX(-50%)',
          whiteSpace: 'nowrap',
          fontSize: '0.72rem',
          color: '#9080a8',
          fontWeight: 500,
          letterSpacing: '0.06em',
          animation: 'floatText 2.5s ease-in-out infinite',
          textShadow: '0 1px 4px rgba(144,128,168,0.2)',
          pointerEvents: 'none',
        }}
      >
        🌙 放松一下
      </div>

      {/* Ultra fluffy mascot - 粉紫色调 */}
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'relative',
          animation: bouncy ? 'bouncy 0.5s cubic-bezier(0.34, 1.8, 0.64, 1)' : 'gentleFloat 3.5s ease-in-out infinite',
        }}
      >
        {/* Core body - round and soft - 粉紫 */}
        <div
          className="absolute inset-0"
          style={{
            borderRadius: '50%',
            background: 'radial-gradient(circle at 40% 35%, #e8d8f0 0%, #d4c0e0 40%, #c0a8d0 70%, #a890c0 100%)',
            boxShadow: `
              0 4px 20px rgba(144,128,168,0.28),
              inset 0 -3px 8px rgba(128,108,160,0.22),
              inset 0 3px 12px rgba(235,220,245,0.45)
            `,
          }}
        />

        {/* Layer 1: Outer fur ring */}
        {Array.from({ length: 20 }).map((_, i) => {
          const a = (i * 18 + 5) * Math.PI / 180;
          const d = 46;
          return (
            <div
              key={`o${i}`}
              className="absolute"
              style={{
                width: i % 2 === 0 ? '14px' : '10px',
                height: i % 2 === 0 ? '18px' : '14px',
                borderRadius: '50%',
                background: `radial-gradient(ellipse at 35% 30%, #e0d0ec, ${i % 3 === 0 ? '#c0a8d0' : '#b098c8'})`,
                top: `calc(50% + ${Math.sin(a) * d}% - ${i % 2 === 0 ? 9 : 7}px)`,
                left: `calc(50% + ${Math.cos(a) * d}% - ${i % 2 === 0 ? 7 : 5}px)`,
                transform: `rotate(${i * 18 + 90}deg)`,
                boxShadow: '0 1px 4px rgba(144,128,168,0.18)',
              }}
            />
          );
        })}

        {/* Layer 2: Mid fur ring */}
        {Array.from({ length: 14 }).map((_, i) => {
          const a = (i * 26 + 12) * Math.PI / 180;
          const d = 38;
          return (
            <div
              key={`m${i}`}
              className="absolute"
              style={{
                width: '10px',
                height: '13px',
                borderRadius: '50%',
                background: `radial-gradient(ellipse at 40% 30%, ${i % 2 === 0 ? '#dcc8e8' : '#d4b8e0'}, ${i % 2 === 0 ? '#c0a0d0' : '#b090c0'})`,
                top: `calc(50% + ${Math.sin(a) * d}% - 6px)`,
                left: `calc(50% + ${Math.cos(a) * d}% - 5px)`,
                transform: `rotate(${i * 26 + 85}deg)`,
              }}
            />
          );
        })}

        {/* Layer 3: Inner fur texture dots */}
        {[
          [30, 22], [65, 18], [50, 30], [25, 42], [70, 40],
          [40, 55], [60, 52], [35, 35], [55, 28], [45, 48],
          [28, 58], [68, 55], [48, 20], [38, 40], [58, 45],
          [32, 30], [62, 35], [42, 60], [52, 50], [35, 48],
        ].map(([x, y], i) => (
          <div
            key={`d${i}`}
            className="absolute"
            style={{
              width: i % 3 === 0 ? '5px' : '3px',
              height: i % 3 === 0 ? '5px' : '3px',
              borderRadius: '50%',
              backgroundColor: i % 2 === 0 ? 'rgba(200,170,220,0.45)' : 'rgba(180,150,200,0.35)',
              top: `${y}%`,
              left: `${x}%`,
            }}
          />
        ))}

        {/* Top ear tufts */}
        <div className="absolute" style={{ width: '10px', height: '14px', borderRadius: '50%', background: 'radial-gradient(ellipse, #dcc8e8, #c0a0d0)', top: '-4px', left: '26%', transform: 'rotate(-25deg)', boxShadow: '0 1px 4px rgba(144,128,168,0.2)' }} />
        <div className="absolute" style={{ width: '10px', height: '14px', borderRadius: '50%', background: 'radial-gradient(ellipse, #dcc8e8, #c0a0d0)', top: '-4px', right: '22%', transform: 'rotate(20deg)', boxShadow: '0 1px 4px rgba(144,128,168,0.2)' }} />
        <div className="absolute" style={{ width: '8px', height: '12px', borderRadius: '50%', background: 'radial-gradient(ellipse, #e0d0ec, #c8a8d8)', top: '-1px', left: '44%', transform: 'rotate(-5deg)' }} />

        {/* 冲天辫 - 更长更蓬松 */}
        <div
          className="absolute"
          style={{
            top: '-30px',
            left: '46%',
            width: '10px',
            height: '42px',
            transformOrigin: '50% 100%',
            animation: 'ponytailSwing 2.2s ease-in-out infinite',
            zIndex: 1,
          }}
        >
          {/* 毛束 */}
          <div
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '50% 50% 40% 40%',
              background: 'radial-gradient(ellipse at 40% 30%, #f0e8f8 0%, #e4d8f0 40%, #d8c8e8 70%, #ccb8e0 100%)',
              boxShadow: '0 1px 4px rgba(180,160,200,0.15)',
            }}
          />
          {/* 毛束纹理 */}
          <div className="absolute" style={{ width: '6px', height: '12px', borderRadius: '50%', background: 'radial-gradient(ellipse, #eadcf4, #d8c4e8)', top: '4px', left: '-2px' }} />
          <div className="absolute" style={{ width: '5px', height: '11px', borderRadius: '50%', background: 'radial-gradient(ellipse, #e6d4f0, #d0b8dc)', top: '10px', right: '-2px' }} />
          <div className="absolute" style={{ width: '4px', height: '9px', borderRadius: '50%', background: 'radial-gradient(ellipse, #e2d0ec, #ccb0d8)', top: '18px', left: '1px' }} />
          <div className="absolute" style={{ width: '3px', height: '7px', borderRadius: '50%', background: 'radial-gradient(ellipse, #dec8e8, #c8acd0)', top: '24px', right: '0px' }} />
        </div>

        {/* 扎绳 */}
        <div
          className="absolute"
          style={{
            width: '12px',
            height: '5px',
            borderRadius: '40%',
            background: 'radial-gradient(ellipse, #9080a8, #706090)',
            top: '-1px',
            left: '45%',
            boxShadow: '0 1px 3px rgba(100,80,140,0.3)',
            zIndex: 4,
          }}
        />

        {/* Left eye - glossy */}
        <div
          className="absolute"
          style={{
            width: eyeState === 'blink' ? '14px' : '16px',
            height: eyeState === 'blink' ? '2px' : '17px',
            borderRadius: eyeState === 'blink' ? '2px' : '50%',
            background: eyeState === 'blink' ? '#2c2420' : 'radial-gradient(circle at 42% 38%, #8a70a0 0%, #5a4070 50%, #1c1028 100%)',
            top: eyeState === 'blink' ? '35%' : '25%',
            left: '20%',
            transition: 'all 0.18s ease',
            boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
            zIndex: 5,
          }}
        >
          {eyeState !== 'blink' && (
            <>
              <div className="absolute" style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.9)', top: '3px', right: '3px' }} />
              <div className="absolute" style={{ width: '3px', height: '3px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.5)', bottom: '4px', left: '3px' }} />
            </>
          )}
        </div>

        {/* Right eye - glossy */}
        <div
          className="absolute"
          style={{
            width: eyeState === 'blink' ? '14px' : '16px',
            height: eyeState === 'blink' ? '2px' : '17px',
            borderRadius: eyeState === 'blink' ? '2px' : '50%',
            background: eyeState === 'blink' ? '#2c2420' : 'radial-gradient(circle at 42% 38%, #8a70a0 0%, #5a4070 50%, #1c1028 100%)',
            top: eyeState === 'blink' ? '35%' : '25%',
            right: '16%',
            transition: 'all 0.18s ease',
            boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
            zIndex: 5,
          }}
        >
          {eyeState !== 'blink' && (
            <>
              <div className="absolute" style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.9)', top: '3px', right: '3px' }} />
              <div className="absolute" style={{ width: '3px', height: '3px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.5)', bottom: '4px', left: '3px' }} />
            </>
          )}
        </div>

        {/* Tiny smile */}
        <div
          className="absolute"
          style={{
            width: '10px',
            height: '4px',
            borderBottom: '1.5px solid #5a4070',
            borderRadius: '0 0 50% 50%',
            bottom: '30%',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 5,
          }}
        />

        {/* Rosy cheeks - 粉紫调 */}
        <div className="absolute" style={{ width: '12px', height: '8px', borderRadius: '50%', background: 'radial-gradient(ellipse, rgba(200, 160, 200, 0.4), transparent 70%)', top: '46%', left: '10%', zIndex: 4 }} />
        <div className="absolute" style={{ width: '12px', height: '8px', borderRadius: '50%', background: 'radial-gradient(ellipse, rgba(200, 160, 200, 0.4), transparent 70%)', top: '46%', right: '8%', zIndex: 4 }} />

        {/* Little feet */}
        <div className="absolute" style={{ width: '16px', height: '11px', borderRadius: '50%', background: 'radial-gradient(ellipse at 40% 30%, #dcc8e8, #c0a0d0)', bottom: '-3px', left: '20%', boxShadow: '0 2px 5px rgba(144,128,168,0.2)', zIndex: 3 }} />
        <div className="absolute" style={{ width: '16px', height: '11px', borderRadius: '50%', background: 'radial-gradient(ellipse at 40% 30%, #dcc8e8, #c0a0d0)', bottom: '-3px', right: '16%', boxShadow: '0 2px 5px rgba(144,128,168,0.2)', zIndex: 3 }} />
      </div>

      <style>{`
        @keyframes gentleFloat {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          33% { transform: translateY(-5px) rotate(1.5deg); }
          66% { transform: translateY(-3px) rotate(-1deg); }
        }
        @keyframes ponytailSwing {
          0%, 100% { transform: rotate(-15deg); }
          50% { transform: rotate(20deg); }
        }
        @keyframes bouncy {
          0% { transform: scale(1) translateY(0); }
          25% { transform: scale(0.9) translateY(5px); }
          50% { transform: scale(1.12) translateY(-10px) rotate(-3deg); }
          75% { transform: scale(0.97) translateY(2px); }
          100% { transform: scale(1) translateY(0) rotate(0deg); }
        }
        @keyframes floatText {
          0%, 100% { transform: translateX(-50%) translateY(0); opacity: 0.85; }
          50% { transform: translateX(-50%) translateY(-4px); opacity: 1; }
        }
      `}</style>
    </div>
  );
}
